var render, staticRenderFns
import script from "./AuctionViewPage.vue?vue&type=script&lang=js&"
export * from "./AuctionViewPage.vue?vue&type=script&lang=js&"
import style0 from "./AuctionViewPage.vue?vue&type=style&index=0&id=37938ed0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37938ed0",
  null
  
)

export default component.exports